import { Fragment } from 'react';
import { Provider } from 'react-redux';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { TattooShop } from './views/TattooShop';
import { Background } from './components/Background';
import { store } from './redux';

const LayoutComponent = () => (
	<Provider store={store}>
		<Fragment>
			<Background />
			<TattooShop />
		</Fragment>
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.TattooShop)
	.build();

export default Layout;
